import { Page, PageContent } from 'components/layout/page';
import PageTopBar from 'components/navigation/PageTopBar';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'components/ui/accordion';
import { supportEmail } from 'locales/fr/translation';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import socialInstagram from '../assets/social-instagram.png';
import socialLinkedin from '../assets/social-linkedin.png';

const data = [
  {
    key: '1',
    label: 'Quelles questions puis-je poser sur Gynger ?',
    children: (
      <div>
        <p>
          🤔 “Qui dois-je consulter pour… ?” “Est-ce que c’est normal que je … ?” “Qu’est-ce ça veut dire … ?” “Que
          faire si je me sens… ?”…
        </p>
        <p>Posez votre question sur Gynger, un soignant vous répondra rapidement !</p>
        <p>
          🧑‍⚕️ Gynger est la messagerie gynécologique pour toutes! Derrière celle-ci, nous avons mobilisé des
          professionnels de santé et des thérapeutes avec des expertises complémentaires et variées. Notre objectif est
          qu'avec Gynger vous soyez informée, accompagnée et orientée selon vos besoins.
        </p>
        <p>
          🙌 Vous pouvez donc poser toutes vos questions de santé féminine qui vous préoccupent, d'une simple recherche
          d'information à l'attente d'un avis médical, nous sommes à votre écoute.
        </p>
      </div>
    ),
  },
  {
    key: '5',
    label: "Est-ce que mon employeur / ma mutuelle sait que j'utilise Gynger ?",
    children: (
      <div>
        <p>Non 🌞</p>
        <p>
          Si vous avez créé un compte avec un code partenaire, votre employeur / votre mutuelle ne sait pas que vous
          utilisez Gynger et n'a aucun accès à vos données sur l'application. Les conversations comme vos données
          présentes sur l'applications sont strictement confidentielles.
        </p>
        <p>Vos données sont bien entendu tout aussi confidentielles si vous avez créé un compte gratuit.</p>
      </div>
    ),
  },
  {
    key: '6',
    label: 'Qui a accès aux conversations que je mène sur Gynger ?',
    children: (
      <div>
        <p>
          Vos conversations sont accessibles uniquement par vous et par l'équipe de soignants avec qui vous communiquez.
          Chaque membre de notre équipe de soins est tenu au secret médical ou secret professionnel, vos conversations
          sont donc strictement confidentielles.
        </p>
      </div>
    ),
  },
  {
    key: '7',
    label: 'Puis-je utiliser Gynger alors que je n’ai aucune pathologie ou que je ne suis pas une femme ?',
    children: (
      <div>
        <p>
          Bien sûr 🌻 Gynger s’adresse à tout.e.s celles et ceux qui souhaitent être informé.e.s, accompagné.e.s et
          orienté.e.s dans leur parcours de soins ou celui de leur proche. Nos soignants sont spécialisés en santé
          féminine et apporteront des réponses bienveillantes à tout.e.s !
        </p>
      </div>
    ),
  },
  {
    key: '8',
    label: 'Puis-je avoir confiance dans les experts de Gynger ?',
    children: (
      <div>
        <ul className="list-disc ps-3">
          <li>
            Gynger a pris soin de sélectionner des professionnels de santé et des thérapeutes formés spécifiquement aux
            problématiques de santé féminine que vous pouvez rencontrer,
          </li>
        </ul>
        <p />
        <ul className="list-disc ps-3">
          <li>
            Chacun d'eux s'est engagé à respecter notre charte de bienveillance et sera à votre écoute pour que vous
            vous sentiez au mieux,
          </li>
        </ul>
        <p />
        <ul className="list-disc ps-3">
          <li>La messagerie Gynger a un taux de satisfaction supérieur à 95% auprès des premières utilisatrices!</li>
        </ul>
      </div>
    ),
  },
  {
    key: '9',
    label: 'Est-ce que Gynger remplace une consultation médicale ?',
    children: (
      <div>
        <p>
          L’accompagnement par chat proposé par Gynger est complémentaire à la consultation physique, et ne vient en
          aucun cas la remplacer. En cas d’urgence, appelez le 15 ! ☎️
        </p>
      </div>
    ),
  },
  {
    key: '11',
    label: 'Est-ce que mes données personnelles sont en sécurité ?',
    children: (
      <div>
        <ul className="list-disc ps-3">
          <li>
            L'application Gynger et vos données personnelles sont hébergées sur un serveur agréé Hébergeur de Données de
            Santé par le Ministère de la Santé et nous respectons minutieusement la loi sur le Règlement Général de
            Protection des Données.
          </li>
        </ul>
        <ul className="list-disc ps-3">
          <li>
            Aussi, grâce à l’expertise de son équipe technique, Gynger a pris soin de mettre en place des procédures qui
            garantissent la sécurité de vos données de bout en bout.
          </li>
        </ul>
      </div>
    ),
  },
];

export default function FaqPage() {
  // Hooks
  const { t } = useTranslation();

  return (
    <Page>
      <PageTopBar title={t('appName')} />

      <PageContent className="gap-4">
        <h4 className="text-foreground">{t('faq.networks')}</h4>

        <div className="flex flex-row justify-center gap-5">
          <Link to={t('social.instagram')} target="_blank" rel="noopener noreferrer">
            <img alt="social-instagram" height={50} width={50} className="size-12" src={socialInstagram} />
          </Link>
          <Link to={t('social.linkedIn')} target="_blank" rel="noopener noreferrer">
            <img alt="social-linkedIn" height={50} width={50} className="size-12" src={socialLinkedin} />
          </Link>
        </div>

        <h4 className="text-foreground">{t('faq.questions')}</h4>

        {/* Each item is its own card (background, radius, own padding), not a seamless stack. */}
        <Accordion type="single" collapsible>
          {data.map(item => (
            <AccordionItem key={item.key} value={item.key}>
              <AccordionTrigger>{item.label}</AccordionTrigger>
              <AccordionContent className="[&_p]:my-3">{item.children}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <p className="text-muted-foreground mt-8 mb-16 text-center">
          <Trans
            i18nKey="settings.supportParagraph"
            components={{ a: <Link to={`mailto:${supportEmail}`} />, br: <br /> }}
          />
        </p>
      </PageContent>
    </Page>
  );
}
